module.exports = __webpack_public_path__ + "img/404.7e9af378.png";